import React, { useContext, useState } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { useCurrentTheme } from 'app/shared/theme';
import { AuthContext } from 'app/shared/context/Auth';
import { Box, Typography } from 'app/shared/components/atoms';
import { NavigationLink as Link } from 'app/shared/components/atoms';
import { ActionLink } from 'app/shared/components/atoms';

import { PromoCodeForm } from './PromoCodeForm';

export const PromoCodeLink = () => {
  const { loggedIn } = useContext(AuthContext);
  const intl = useIntl();
  const [displayPromoCodeForm, setDisplayPromoCodeForm] = useState(false);
  const location = useLocation();
  const { colors } = useCurrentTheme();

  if (displayPromoCodeForm) {
    return <PromoCodeForm />;
  }

  if (loggedIn) {
    return (
      <Box flexDirection="row">
        <ActionLink
          textDecoration="underline"
          fontWeight="regular"
          onClick={() => setDisplayPromoCodeForm(true)}
          color={colors.primary.black.base}
        >
          {intl.formatMessage({
            id: 'event.expressCheckout.promoCode.haveAPromoCode',
          })}
        </ActionLink>
      </Box>
    );
  }

  return (
    <Box flexDirection="row">
      <Typography fontWeight="regular" color={colors.primary.black.base}>
        {intl.formatMessage({
          id: 'event.expressCheckout.promoCode.haveAPromoCodeLoggedOut1',
        })}
        <Link
          href={`/signin?return_to=${location.pathname}`}
          color={colors.primary.black.base}
        >
          {intl.formatMessage({
            id: 'event.expressCheckout.promoCode.haveAPromoCodeLoggedOut2',
          })}
        </Link>
        {intl.formatMessage({
          id: 'event.expressCheckout.promoCode.haveAPromoCodeLoggedOut3',
        })}
      </Typography>
    </Box>
  );
};
